import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { publicFaqs } from "@/content/publicFaqs";

interface PublicFaqSectionProps {
  title?: string;
  description?: string;
}

const PublicFaqSection = ({
  title = "Questions teams ask before backing up Jotform",
  description = "Short answers for the common decisions around form backups, restore coverage, and data scope.",
}: PublicFaqSectionProps) => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">{title}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{description}</p>
        </div>

        <Accordion type="single" collapsible className="max-w-3xl mx-auto border rounded-lg bg-background px-4">
          {publicFaqs.map((item, index) => (
            <AccordionItem key={item.question} value={`faq-${index}`}>
              <AccordionTrigger className="text-left text-base font-semibold">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default PublicFaqSection;
